module.exports = __webpack_public_path__ + "static/media/flight.88b4a8e7.svg";